import React from 'react'

export const CrossOut = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 41 41"
    preserveAspectRatio="none"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="0" y1="0" x2="41" y2="41" stroke="#C4C7C9" strokeWidth="1" />
    <line x1="0" y1="41" x2="41" y2="0" stroke="#C4C7C9" strokeWidth="1" />
  </svg>
)
